import { createFileRoute, redirect } from '@tanstack/react-router';

import { legacySettingsSearch, validateLegacyTeamSearch } from '@/pages/settings/settings-tabs';

/**
 * The standalone Integrations hub is gone (Appendix A §9 cut list) — it is
 * Team settings › Integrations now. Old `/integrations` links redirect.
 */
export const Route = createFileRoute('/integrations')({
  validateSearch: validateLegacyTeamSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings', search: legacySettingsSearch('integrations', search) });
  },
});
